/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetSuborderPrescriptionParams,
  GetSubordersParams,
  HTTPValidationError,
  MarkSuborderDeliveredParams,
  PageSuborderManyRead,
  SplitSuborderProductParams,
  SuborderWithOrder,
  ToggleSuborderChargeback200,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to get many suborders.

Results are paginated and filtered based on the current user's role.
 * @summary Get Suborders
 */
export const getSuborders = (
  params?: GetSubordersParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageSuborderManyRead>({
    url: `/api/suborder/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSubordersQueryKey = (params?: GetSubordersParams) => {
  return ["api", "suborder", ...(params ? [params] : [])] as const;
};

export const getGetSubordersQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborders>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSubordersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuborders>>> = ({
    signal,
  }) => getSuborders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuborders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubordersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuborders>>
>;
export type GetSubordersQueryError = ErrorType<void | HTTPValidationError>;

export function useGetSuborders<
  TData = Awaited<ReturnType<typeof getSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetSubordersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborders>>,
          TError,
          Awaited<ReturnType<typeof getSuborders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborders<
  TData = Awaited<ReturnType<typeof getSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborders>>,
          TError,
          Awaited<ReturnType<typeof getSuborders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborders<
  TData = Awaited<ReturnType<typeof getSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Suborders
 */

export function useGetSuborders<
  TData = Awaited<ReturnType<typeof getSuborders>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetSubordersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborders>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSubordersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an suborder by ID.
 * @summary Get Suborder
 */
export const getSuborder = (suborderId: string, signal?: AbortSignal) => {
  return customInstance<SuborderWithOrder>({
    url: `/api/suborder/${suborderId}`,
    method: "GET",
    signal,
  });
};

export const getGetSuborderQueryKey = (suborderId?: string) => {
  return ["api", "suborder", suborderId] as const;
};

export const getGetSuborderQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborder>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuborderQueryKey(suborderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuborder>>> = ({
    signal,
  }) => getSuborder(suborderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!suborderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuborder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSuborderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuborder>>
>;
export type GetSuborderQueryError = ErrorType<void | HTTPValidationError>;

export function useGetSuborder<
  TData = Awaited<ReturnType<typeof getSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborder>>,
          TError,
          Awaited<ReturnType<typeof getSuborder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborder<
  TData = Awaited<ReturnType<typeof getSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborder>>,
          TError,
          Awaited<ReturnType<typeof getSuborder>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborder<
  TData = Awaited<ReturnType<typeof getSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Suborder
 */

export function useGetSuborder<
  TData = Awaited<ReturnType<typeof getSuborder>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuborder>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSuborderQueryOptions(suborderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a PDF prescription for a suborder by ID.
 * @summary Get Suborder Prescription
 */
export const getSuborderPrescription = (
  suborderId: string,
  suborderProductId: number,
  params?: GetSuborderPrescriptionParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/suborder/${suborderId}/${suborderProductId}/prescription`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getGetSuborderPrescriptionQueryKey = (
  suborderId?: string,
  suborderProductId?: number,
  params?: GetSuborderPrescriptionParams,
) => {
  return [
    "api",
    "suborder",
    suborderId,
    suborderProductId,
    "prescription",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSuborderPrescriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuborderPrescription>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  suborderProductId: number,
  params?: GetSuborderPrescriptionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderPrescription>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuborderPrescriptionQueryKey(suborderId, suborderProductId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuborderPrescription>>
  > = ({ signal }) =>
    getSuborderPrescription(suborderId, suborderProductId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(suborderId && suborderProductId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuborderPrescription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSuborderPrescriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuborderPrescription>>
>;
export type GetSuborderPrescriptionQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetSuborderPrescription<
  TData = Awaited<ReturnType<typeof getSuborderPrescription>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  suborderProductId: number,
  params: undefined | GetSuborderPrescriptionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderPrescription>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborderPrescription>>,
          TError,
          Awaited<ReturnType<typeof getSuborderPrescription>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborderPrescription<
  TData = Awaited<ReturnType<typeof getSuborderPrescription>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  suborderProductId: number,
  params?: GetSuborderPrescriptionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderPrescription>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborderPrescription>>,
          TError,
          Awaited<ReturnType<typeof getSuborderPrescription>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborderPrescription<
  TData = Awaited<ReturnType<typeof getSuborderPrescription>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  suborderProductId: number,
  params?: GetSuborderPrescriptionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderPrescription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Suborder Prescription
 */

export function useGetSuborderPrescription<
  TData = Awaited<ReturnType<typeof getSuborderPrescription>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  suborderProductId: number,
  params?: GetSuborderPrescriptionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderPrescription>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSuborderPrescriptionQueryOptions(
    suborderId,
    suborderProductId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get a PDF receipt for a suborder by ID.
 * @summary Get Suborder Receipt
 */
export const getSuborderReceipt = (
  suborderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/suborder/${suborderId}/receipt`,
    method: "GET",
    responseType: "blob",
    signal,
  });
};

export const getGetSuborderReceiptQueryKey = (suborderId?: string) => {
  return ["api", "suborder", suborderId, "receipt"] as const;
};

export const getGetSuborderReceiptQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuborderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderReceipt>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSuborderReceiptQueryKey(suborderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuborderReceipt>>
  > = ({ signal }) => getSuborderReceipt(suborderId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!suborderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuborderReceipt>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSuborderReceiptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuborderReceipt>>
>;
export type GetSuborderReceiptQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetSuborderReceipt<
  TData = Awaited<ReturnType<typeof getSuborderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderReceipt>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborderReceipt>>,
          TError,
          Awaited<ReturnType<typeof getSuborderReceipt>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborderReceipt<
  TData = Awaited<ReturnType<typeof getSuborderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderReceipt>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuborderReceipt>>,
          TError,
          Awaited<ReturnType<typeof getSuborderReceipt>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSuborderReceipt<
  TData = Awaited<ReturnType<typeof getSuborderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderReceipt>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Suborder Receipt
 */

export function useGetSuborderReceipt<
  TData = Awaited<ReturnType<typeof getSuborderReceipt>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  suborderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuborderReceipt>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSuborderReceiptQueryOptions(suborderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to mark a suborder as delivered by ID.
 * @summary Mark Suborder Delivered
 */
export const markSuborderDelivered = (
  suborderId: string,
  params: MarkSuborderDeliveredParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/suborder/${suborderId}/delivered`,
    method: "POST",
    params,
    signal,
  });
};

export const getMarkSuborderDeliveredMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markSuborderDelivered>>,
    TError,
    { suborderId: string; params: MarkSuborderDeliveredParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markSuborderDelivered>>,
  TError,
  { suborderId: string; params: MarkSuborderDeliveredParams },
  TContext
> => {
  const mutationKey = ["markSuborderDelivered"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markSuborderDelivered>>,
    { suborderId: string; params: MarkSuborderDeliveredParams }
  > = (props) => {
    const { suborderId, params } = props ?? {};

    return markSuborderDelivered(suborderId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkSuborderDeliveredMutationResult = NonNullable<
  Awaited<ReturnType<typeof markSuborderDelivered>>
>;

export type MarkSuborderDeliveredMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Mark Suborder Delivered
 */
export const useMarkSuborderDelivered = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markSuborderDelivered>>,
      TError,
      { suborderId: string; params: MarkSuborderDeliveredParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markSuborderDelivered>>,
  TError,
  { suborderId: string; params: MarkSuborderDeliveredParams },
  TContext
> => {
  const mutationOptions = getMarkSuborderDeliveredMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to toggle the chargeback status of a suborder by ID.
 * @summary Toggle Suborder Chargeback
 */
export const toggleSuborderChargeback = (
  suborderId: string,
  signal?: AbortSignal,
) => {
  return customInstance<ToggleSuborderChargeback200>({
    url: `/api/suborder/${suborderId}/chargeback`,
    method: "POST",
    signal,
  });
};

export const getToggleSuborderChargebackMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleSuborderChargeback>>,
    TError,
    { suborderId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleSuborderChargeback>>,
  TError,
  { suborderId: string },
  TContext
> => {
  const mutationKey = ["toggleSuborderChargeback"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleSuborderChargeback>>,
    { suborderId: string }
  > = (props) => {
    const { suborderId } = props ?? {};

    return toggleSuborderChargeback(suborderId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleSuborderChargebackMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleSuborderChargeback>>
>;

export type ToggleSuborderChargebackMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Toggle Suborder Chargeback
 */
export const useToggleSuborderChargeback = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleSuborderChargeback>>,
      TError,
      { suborderId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof toggleSuborderChargeback>>,
  TError,
  { suborderId: string },
  TContext
> => {
  const mutationOptions = getToggleSuborderChargebackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to split a suborder product into two rows.
 * @summary Split Suborder Product
 */
export const splitSuborderProduct = (
  suborderId: string,
  suborderProductId: number,
  params: SplitSuborderProductParams,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/suborder/${suborderId}/products/${suborderProductId}/split`,
    method: "POST",
    params,
    signal,
  });
};

export const getSplitSuborderProductMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof splitSuborderProduct>>,
    TError,
    {
      suborderId: string;
      suborderProductId: number;
      params: SplitSuborderProductParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof splitSuborderProduct>>,
  TError,
  {
    suborderId: string;
    suborderProductId: number;
    params: SplitSuborderProductParams;
  },
  TContext
> => {
  const mutationKey = ["splitSuborderProduct"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof splitSuborderProduct>>,
    {
      suborderId: string;
      suborderProductId: number;
      params: SplitSuborderProductParams;
    }
  > = (props) => {
    const { suborderId, suborderProductId, params } = props ?? {};

    return splitSuborderProduct(suborderId, suborderProductId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type SplitSuborderProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof splitSuborderProduct>>
>;

export type SplitSuborderProductMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Split Suborder Product
 */
export const useSplitSuborderProduct = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof splitSuborderProduct>>,
      TError,
      {
        suborderId: string;
        suborderProductId: number;
        params: SplitSuborderProductParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof splitSuborderProduct>>,
  TError,
  {
    suborderId: string;
    suborderProductId: number;
    params: SplitSuborderProductParams;
  },
  TContext
> => {
  const mutationOptions = getSplitSuborderProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
